import React from "react";
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
  InfoCircleOutlined,
  QuestionCircleOutlined,
} from "@ant-design/icons";
import CustomSeparator from "../Common/CustomSeparator";
import Text from "./Text";
import CustomButton from "../CustomButton/CustomButton";
import useEmpresa from "../../hooks/useEmpresa";
import {
  AlertContainer,
  AlertContent,
  AlertButtonContainer,
} from "./CommonStyles";
import Colors from "../../themes/Colors";
import CheckRender from "../Common/CheckRender";

const CustomAlert = ({
  type,
  title,
  message,
  onConfirm,
  onCancel,
  confirmText,
  cancelText,
  aditionalInfo
}) => {
  const empresa = useEmpresa();
  let IconComponent;

  switch (type) {
    case "success":
      IconComponent = () => (
        <CheckCircleOutlined
          style={{ color: empresa?.COLOR_PRINCIPAL, fontSize: 35 }}
        />
      );
      break;
    case "error":
      IconComponent = () => (
        <CloseCircleOutlined
          style={{ color: empresa?.COLOR_PRINCIPAL, fontSize: 35 }}
        />
      );
      break;
    case "info":
      IconComponent = () => (
        <InfoCircleOutlined style={{ color: empresa?.COLOR_PRINCIPAL, fontSize: 35 }} />
      );
      break;
    case "confirm":
      IconComponent = () => (
        <QuestionCircleOutlined
          style={{ color: empresa?.COLOR_PRINCIPAL, fontSize: 35 }}
        />
      );
      break;
    default:
      IconComponent = null;
      break;
  }

  return (
    <AlertContainer>
      {IconComponent && <IconComponent />}

      <CustomSeparator height={"10px"} />

      <AlertContent>
        <Text size="20px" isTittle={true} weight={"bold"} margin={"1"}>
          {title}
        </Text>
        <Text size="15px" margin={"0"}>
          {message}
        </Text>
        <CustomSeparator height={"5px"} />
        <CheckRender allowed={aditionalInfo}>
          <Text size="15px" margin={"0"}>
            {aditionalInfo}
          </Text>
        </CheckRender>
      </AlertContent>

      {(onConfirm || onCancel) && (
        <AlertButtonContainer>
          {onConfirm && (
            <CustomButton
              label={confirmText || "De acuerdo"}
              onClick={onConfirm}
              weight={"bold"}
              hoverColor={empresa?.COLOR_PRINCIPAL}
              bgColor={Colors.white}
              textColor={empresa?.COLOR_PRINCIPAL}
              border={`1px solid ${empresa?.COLOR_PRINCIPAL}`}
            />
          )}
          <CustomSeparator width={"10px"} />
          {onCancel && (
            <CustomButton
              label={cancelText || "Cancelar"}
              onClick={onCancel}
              weight={"bold"}
              hoverColor={Colors.huMyHealth}
              bgColor={Colors.white}
              textColor={Colors.huMyHealth}
              border={`1px solid ${Colors.huMyHealth}`}
            />
          )}
        </AlertButtonContainer>
      )}
    </AlertContainer>
  );
};

export default CustomAlert;